import themeVariables from '../theme-variables.js';
import { createTheme } from '@jetshop/ui/Theme/createTheme';

// Edit your theme values at `src/theme-variables.js`
const theme = createTheme(themeVariables);

export { theme };
